import React from 'react';
import PropTypes from 'prop-types';
import { useInstantSearch } from 'react-instantsearch';
import { Picture } from '../../../ui/Picture';
import { useGetProductCategoriesQuery } from '../../../../redux-modules/service';

export default function CategoryHit({
  hit,
  additionalData,
}) {
  const {
    id,
    title,
    url,
    uri,
    productImages,
    level,
    subText,
  } = hit;

  const { results } = useInstantSearch();
  const hitIndex = results.hits.findIndex((h) => h.id === id);
  const lazyLoadImage = hitIndex > 9;
  const {
    onCategoryChanged,
    translates,
  } = additionalData;

  const { catalog } = translates;

  const { data: categoryData, isFetching: isCategoryDataFetching } = useGetProductCategoriesQuery();

  if (isCategoryDataFetching || categoryData.categories.length === 0) {
    return Craft.t(catalog, 'Loading...');
  }

  // find the hit in the category tree to be able to check the product amount
  let category = categoryData.categories.flatMap((c) => c.children).find((d) => d.id === id);
  if (level === 4) {
    category = categoryData.categories.flatMap((c) => c.children)
      .flatMap((c) => c.children)
      .flatMap((c) => c.children)
      .find((d) => d.id === id);
  } else if (level === 3) {
    category = categoryData.categories.flatMap((c) => c.children)
      .flatMap((c) => c.children)
      .find((d) => d.id === id);
  }

  return (category?.productCount.length && (
    <div className="col-12 col-sm-6 col-lg-4 d-flex mb-2b mb-lg-4a">
      <a
        className="card-product card-category"
        href={url}
        onClick={(e) => {
          onCategoryChanged(uri);
          window.history.pushState(null, '', url);
          e.preventDefault();
        }}
      >
        <div className="card-product-img">
          {productImages?.length > 0 && (
            <Picture image={productImages?.[0]} alt={title} defaultTransform="xl-min" loading={lazyLoadImage ? 'lazy' : 'eager'} fetchPriority={lazyLoadImage ? 'auto' : 'high'} />
          )}
        </div>
        <div className="card-product-body">
          <h3>{title}</h3>
          <span className="exception">
            {subText ?? (category?.productCount && (
              Craft.t(catalog, '{count, plural, =1{# edition} other{# editions}}', { count: parseInt(category.productCount, 10) })
            ))}
          </span>
        </div>
      </a>
    </div>
  ));
}

CategoryHit.propTypes = {
  hit: PropTypes.shape({
    id: PropTypes.number,
    level: PropTypes.number,
    title: PropTypes.string,
    subText: PropTypes.string,
    url: PropTypes.string,
    uri: PropTypes.string,
    productImages: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
    })),
  }),
  additionalData: PropTypes.objectOf(PropTypes.any),
};
